import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { ContainerTypes } from "@/types/containerTypes";
import { copyPasteTypes } from "@/types/copyPasteTypes";
import { Dropdown, Form } from "react-bootstrap";
import { BasicButton } from "../buttons/BasicButton";
import { CopyItem } from "../dropdown/CopyItem";
import { CustomToggle } from "../dropdown/CustomToggle";
import { DeleteItem } from "../dropdown/DeleteItem";
import { DuplicateItem } from "../dropdown/DuplicateItem";
import { PasteItem } from "../dropdown/PasteItem";
import { Scenario } from "./Scenario";
import { CollapsibleAddRow } from "../buttons/CollapsibleAddRow";
import { Step } from "@/backend/models/containers/step";
import { ContainerTreeObject } from "@/frontend/types/navigationTypes";


export function ScenarioWrapper(props: { stepNode: ContainerTreeObject }) {
  const { stepNode } = props;

  const step = stepNode.container as Step;
  const createContainer = useTreeStore((state) => state.createContainer);
  const updateContainer = useTreeStore((state) => state.updateContainer);
  const deleteContainer = useTreeStore((state) => state.deleteContainer);
  const duplicateContainer = useTreeStore((state) => state.duplicateContainer);
  const fetchContainer = useTreeStore((state) => state.fetchContainer);
  const scenarios = useTreeStore((state) => state.childContainers(step.id));

  const selectedScenario = scenarios.find((scenario) => scenario.container.id === step.selectedScenarioId) || scenarios[0];

  const createScenario = async () => {
    const response = await createContainer({ container: {
      containerType: ContainerTypes.Scenario,
      parentId: step.id,
      rootId: step.rootId,
      rootType: step.rootType,
      parentType: step.parentType,
      isScaffold: stepNode.container.isScaffold,
      position: 0
    }});

    if (response.status === 200) {
      void fetchContainer(step.id);
    }

  };

  if (scenarios.length === 0) return null;

  return (
    <div className="card-body p-0">
      <div id={step.selectedScenarioId} className="card bg-light border border-dark-subtle observed-element p-3">
          <div className='d-flex justify-content-between align-items-center'>
            <small className='text-muted text-uppercase mb-2'>
              <label htmlFor={step.selectedScenarioId}>
                {I18n.get('scenario')}
              </label>
            </small>
            <div className="dropdown dropdown-menu-end">
              <Dropdown drop='down'>
                <Dropdown.Toggle size='sm' as={CustomToggle(copyPasteTypes.Scenario)} variant='dark' id="dropdown-basic" />
                <Dropdown.Menu>
                  <PasteItem item={selectedScenario.container} instance={ContainerTypes.Scenario} isScaffold={selectedScenario.container.isScaffold} />
                  <CopyItem instance={ContainerTypes.Scenario} itemId={selectedScenario.container.id} />
                  <DeleteItem deleteAction={() => deleteContainer(selectedScenario.container)} itemType={ContainerTypes.Scenario} title={selectedScenario.container.title} disabled={scenarios.length === 1} disabledMessage={I18n.get('cannotDeleteLastScenario')} />
                  <DuplicateItem onClickDupe={() => void duplicateContainer(selectedScenario.container.id)} />
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className="d-flex flex-column">
            { scenarios.length > 1 && (
              <div className='d-flex gap-2 align-items-center'>
                <Form.Select data-testid='scenarioSelect' aria-label={I18n.get('selectScenario')} value={selectedScenario.container.id} onChange={(event) => { void updateContainer({ container: { ...step, selectedScenarioId: event.target.value }}); }}>
                  {scenarios.map((scenario) => <option key={scenario.id} value={scenario.id}>{scenario.container.title}</option>)}
                </Form.Select>
              </div>
            )}
            <CollapsibleAddRow label={I18n.get('addScenarioHere')}>
              <BasicButton onClick={createScenario} label={I18n.get('addScenario')} className='btn btn-sm btn-primary align-self-start' />
            </CollapsibleAddRow>
            {selectedScenario && <Scenario key={selectedScenario.id} scenario={selectedScenario} /> }
        </div>
      </div>
    </div>);
}
